import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Sidebar({ onAddNode, onSaveFlow, onLoadPredefinedFlow }) {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState('');

  const predefinedFlows = [
    { name: 'Cuenta Diaria', key: 'cuenta' },
    { name: 'Crédito Personal', key: 'credito' },
    { name: 'Tarjeta de Crédito', key: 'tarjeta' },
    { name: 'Adelanto de Nómina', key: 'nomina' },
    { name: 'Préstamo', key: 'prestamo' },
    { name: 'Hipoteca', key: 'hipoteca' },
    { name: 'Onboarding Cliente', key: 'onboarding' },
    { name: 'Test KYC Avanzado', key: 'kyc-test' }, // 🧪 Flujo mock
  ];

  const stepTypes = [
    { label: 'Formulario', value: 'formulario' },
    { label: 'Validación', value: 'validacion' },
    { label: 'Documento', value: 'documento' },
    { label: 'Informativo', value: 'informativo' },
  ];

  const handleTemplateChange = (e) => {
    const value = e.target.value;
    setSelectedTemplate(value);
    if (value) {
      onLoadPredefinedFlow(value);
    }
  };

  const sharedStyle = {
    width: '100%',
    maxWidth: '220px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    padding: '0.5rem 0.75rem',
    display: 'block',
    marginLeft: '10px',
    marginRight: '70px',
  };

  return (
    <div
      className="column is-12-mobile is-4-tablet is-3-desktop has-background-dark py-5"
      style={{ paddingLeft: '2.5rem', paddingRight: '2.5rem' }}
    >
      <div className="has-text-centered mt-4 mb-5">
        <a href="https://kukenfi.com" target="_blank" rel="noopener noreferrer">
          <img
            src="https://kukenfi.kukenandev.es/logo/logo_oscuro.svg"
            alt="Kukenfi Logo"
            style={{ maxWidth: '60%', height: 'auto' }}
          />
        </a>
      </div>

      <h3 className="title is-6 has-text-light">Flujos Predefinidos</h3>
      <div className="is-flex is-justify-content-center mb-5">
        <div className="select is-small" style={sharedStyle}>
          <select value={selectedTemplate} onChange={handleTemplateChange}>
            <option value="">Seleccionar flujo...</option>
            {predefinedFlows.map((flow) => (
              <option key={flow.key} value={flow.key}>
                {flow.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <h3 className="title is-6 has-text-light">Agregar Paso</h3>
      {stepTypes.map(({ label, value }) => (
        <div className="is-flex is-justify-content-center mb-3" key={value}>
          <button
            className="button is-link is-small"
            onClick={() => onAddNode(value)}
            style={sharedStyle}
          >
            + {label}
          </button>
        </div>
      ))}

      <h3 className="title is-6 has-text-light mt-5">Otras Herramientas</h3>
      {['Caja', 'Condicional', 'Entrada'].map((type) => (
        <div className="is-flex is-justify-content-center mb-3" key={type}>
          <button
            className="button is-info is-small"
            onClick={() => onAddNode(type)}
            style={sharedStyle}
          >
            Agregar {type}
          </button>
        </div>
      ))}

      <hr className="my-3" />

      <div className="is-flex is-justify-content-center mb-3">
        <button
          className="button is-primary is-small"
          onClick={onSaveFlow}
          style={sharedStyle}
        >
          Guardar Flujo
        </button>
      </div>

      <div className="is-flex is-justify-content-center">
        <button
          className="button is-warning is-small"
          onClick={() => navigate('/flows')}
          style={sharedStyle}
        >
          Listar Flujos
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
